module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/gift_2-d68116048feb90cba009867dd855f17c.png";